var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVinniJaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96.779289mm",
    height: "98.297028mm",
    viewBox: "0 0 96.779289 98.297028",
    id: "svg145",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs142"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-57.987759,-113.63033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1162",
    transform: "matrix(0.26458333,0,0,0.26458333,-143.59651,93.329383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 827.21344,322.01214 37.72642,-14.5762 36.01158,-2.5722 31.05379,1.55062 -29.33895,19.88488 -14.16747,5.73458 -19.27185,-6.59208 -23.15031,-2.5722 z",
    id: "path4339-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 814.15188,329.64674 c 21.30301,-5.5306 44.31699,-10.3149 72.76561,5.21479 l 6.47266,-4.03909 c -17.27745,-4.4817 -29.4279,-14.1597 -60.09765,-9.6386 3.78215,-1.5382 7.42969,-2.9551 10.97656,-4.2793 30.69273,-10.6139 46.08007,-8.5743 46.08007,-8.5743 15.99091,-0.7703 15.99884,2.9718 38.76967,0.8504 l 11.5625,-7.2644 c -10.93427,0.094 -22.39529,1.2484 -38.72475,0.2832 -19.09727,0.1225 -38.72722,3.1788 -58.81835,8.7676 -28.60622,16.682 -28.98632,18.6797 -28.98632,18.6797 z",
    id: "path4235-9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinniJaw);
export default __webpack_public_path__ + "static/media/vinni-jaw.a7a98c0c96534291c8c012a47b52b987.svg";
export { ForwardRef as ReactComponent };